import { useI18n } from "vue-i18n";

export function useFormatters() {
  const { locale, t } = useI18n();

  const formatDate = (date: Date | string) => {
    const dateObj = date instanceof Date ? date : new Date(date);
    return dateObj.toLocaleDateString(locale.value, {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const formatTime = (time: Date | string) => {
    const timeObj = time instanceof Date ? time : new Date(time);
    return timeObj.toLocaleTimeString(locale.value, {
      hour: "numeric",
      minute: "2-digit",
      hour12: false,
    });
  };

  const formatMonth = (date: Date | string) => {
    const dateObj = date instanceof Date ? date : new Date(date);
    const formattedDate = dateObj.toLocaleDateString(locale.value, {
      month: "long",
      year: "numeric",
    });
    return formattedDate;
  };

  const firstLetterUpperCase = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const formatMonthName = (date: Date | string) => {
    const dateObj = date instanceof Date ? date : new Date(date);
    return dateObj.toLocaleDateString(locale.value, {
      month: "short",
    });
  };

  const formatFullMonthName = (date: Date | string) => {
    const dateObj = date instanceof Date ? date : new Date(date);
    const monthName = dateObj.toLocaleDateString(locale.value, {
      month: "long",
    });
    return locale.value === "da" ? monthName.toLowerCase() : monthName;
  };

  const formatDayName = (date: Date | string) => {
    const dateObj = date instanceof Date ? date : new Date(date);
    const dayMap = {
      0: "sunday",
      1: "monday",
      2: "tuesday",
      3: "wednesday",
      4: "thursday",
      5: "friday",
      6: "saturday",
    };
    return t(
      `components.date_picker.day_names_short.${dayMap[dateObj.getDay()]}`,
    );
  };

  const formatDayNumber = (date: Date | string) => {
    const dateObj = date instanceof Date ? date : new Date(date);
    return dateObj.getDate();
  };

  const calendarDateString = (date: Date | string) => {
    const dateObj = date instanceof Date ? date : new Date(date);
    switch (locale.value) {
      case "da":
        return `${formatDayName(dateObj)} ${formatDayNumber(dateObj)}. ${formatMonthName(dateObj).toLowerCase()}`;
      case "en":
        return `${formatDayName(dateObj)}, ${formatMonthName(dateObj)} ${formatDayNumber(dateObj)}`;
      default:
        throw new Error(
          `Unsupported locale: ${locale.value} in calendarDateString`,
        );
    }
  };

  return {
    formatDate,
    formatTime,
    formatMonth,
    formatMonthName,
    formatDayName,
    formatDayNumber,
    calendarDateString,
    firstLetterUpperCase,
    formatFullMonthName,
  };
}
